<template>
  <div class="item-container" :style="{paddingTop: rem2px(paddingTop), paddingBottom: rem2px(paddingBottom), height: rem2px(height)}">
    <div ref="item">
      <div :class="['item-box', isFixed ? 'item-fixed' : '']" :style="{ top: Number(offsetTop * 0.01333) + 'rem' }">
        <div
        :class="['item', styleStoreType && item.id == 'four' ? 'items':'',searchStyle ==2?'styletwo':'']"
        :style="{ height: rem2px(height)}"
        v-for="(item, index) in filterItems"
        :key="item.type"
        v-if="item.show">
          <div>
            <button
          :class="['content', item.active ? 'active' : '', item.showIcon ? 'has-icon' : '', item.showIconBySingle ? 'has-sigIcon': '']"
          :style="{ height: rem2px(height)}"
          @click="itemClick(item, index)">
            {{item.name}}
            <img :class="item.showIconBySingle?'img_single':'img'" v-if="item.showIcon" :src="!item.showIconBySingle ?item[item.key]: (item.key == 'up' ? single_down : single_up)" alt="">
          </button>
           <img  @click="getSwitchStyle" v-if="styleStoreType && item.id == 'four'" class="imgstyle" :src="isstyle ? styleicon:styleiconActive" alt="">
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common'
export default {
  props: {
    display: Object,
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    },
    offsetTop: {
      type: [Number, String],
      default: 0
    },
    onFixed: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 84
    },
   styleStoreType:{
      type:Boolean,
      value:false,     //  默认没有
    },
    searchStyle:{
      type: [Number, String],
      default:0
    }
  },
  data() {
    const icon = require('@/assets/image/filter-price.png')
    const up = require('@/assets/image/filter-price-up.png')
    const down = require('@/assets/image/filter-price-down.png')
    return {
      single_down: require('@/assets/brand/xia2x.png'),
      single_up:require('@/assets/brand/sha@2x.png'),
      filterItems: [{
        id: 'one',
        name: '综合',
        show: true,
        showIcon: false,
        active: true,
        actived: true,
        key: 'up',
        start: '',
        icon,
        up,
        down
      },{
        id: 'two',
        name: '最新',
        show: true,
        showIcon: false,
        active: false,
        actived: true,
        key: 'icon',
        start: '',
        icon,
        up,
        down
      },{
        id: 'three',
        name: '价格',
        show: true,
        showIcon: false,
        active: false,
        actived: true,
        key: 'icon',
        start: '',
        icon,
        up,
        down,
        showIconBySingle: false,
      },{
        id: 'four',
        name: '筛选',
        show: true,
        showIcon: true,
        active: false,
        actived: true,
        reset: false,
        key: 'icon',
        start: '',
        icon: require('@/assets/image/filter.png'),
        iconActive: require('@/assets/image/filter-active.png')
      },
      ],
      currentIndex: 0,
      isFixed: false,
      fixedTop: '0rem',
      isstyle:false,  // 点击切换样式
      styleicon: 'https://img.chinabeego.com/uploadfile/2021/7/14/162624300740415211975497158275.png',
      styleiconActive: 'https://img.chinabeego.com/uploadfile/2021/7/14/16262430289373814394115234009.png'
    }
  },
  watch: {
    display: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if(newVal) {
          let obj;
          this.filterItems.forEach(item => {
            if(obj = newVal[item.id]) {
              for(let key in obj) {
                item[key] = obj[key]
                if(item.id == 'four' && key == 'active') {
                  item.active = obj.active
                  item.key = obj.active ? 'iconActive' : 'icon'
                }
              }
            }
            if(item.name == '价格' && !item.start) {
              item.start = 'down'
            }
          })
        }
      }
    },
  //  styleStoreType: {
  //     immediate: true,
  //     deep: true,
  //     // handler(newVal) {
  //     //   if(newVal) {
  //     //     var filterItems = this.filterItems;
  //     //     filterItems[4].show = true;
  //     //     this.filterItems = filterItems
  //     //   }
  //     // }
  //   }
  },
  mounted() {
    this.onItemFixed()
  },
  methods: {
    getSwitchStyle(){
      this.isstyle=!this.isstyle;
      this.$emit('ongetSwitchStyle', this.isstyle)
    },

    rem2px: utils.rem2px,
    itemClick(target, index) {
      if(target.reset !== false) {
        this.filterItems.forEach((item, i) => {
          if(item.reset !== false) {
            if(i == index && item.start && item.key == 'icon') {
              item.key = item.start
            } else {
              item.key = i == index
              ? item.showIcon
                ? (item.key == 'icon' || item.key == 'down' ? 'up' : 'down')
                : 'iconActive'
              : 'icon'
            }
            if(item.actived) {
              item.active = item.key != 'icon'
            }
             
          }
        })
        this.currentIndex = index
      }

      let type, key;
      if(target.showIcon && target.reset !== false) {
        type = `${target.id}_${target.key}`
        key = `${target.name}_${target.key}`
      } else {
        type = target.id
        key = target.name + '_up'
      }
      if(index == 4){
        console.log('target.key',target.key)
        if(target.key == 'icon'){
          target.key = 'iconActive'
        }else{
          target.key = 'icon'
        }
      }
      this.$emit('onClick', { type, sort: this.sort[key],index })
    },
    onItemFixed() {
      if(this.onFixed) {
        let offsetTop = utils.rem2px(this.offsetTop, false)
        this.app = document.getElementById('app')
        this.handler = e => {
          this.isFixed = e.target.scrollTop >= this.$refs.item.offsetTop - offsetTop
        }

        this.app.addEventListener('scroll', this.handler)
      }
    },
    reset() {
      this.filterItems.forEach(item => {
        if(item.id != 'four' && item.id != 'one') {
          item.active = false
        }
      })
    }
  },
  computed: {
    sort() {
      return {
        "综合_up": { order: '', type: '' },
        "最热_up": { order: 'DESC', type: 'HOT'},
        "最热_down": { order: 'ASC', type: 'HOT'},
        "最新_up": { order: 'DESC', type: 'NEWEST' },
        "最新_down": { order: 'ASC', type: 'NEWEST' },
        "价格_up": { order: 'ASC', type: 'PRICE' },
        "价格_down": { order: 'DESC', type: 'PRICE' },
        "销量_up": { order: 'ASC', type: 'SALES' },
        "销量_down": { order: 'DESC', type: 'SALES' },
      }
    }
  },
  beforeDestroy() {
    this.app && this.app.removeEventListener('scroll', this.handler)
  }
}
</script>

<style lang="less" scoped>
.items{
  position: relative;
   flex-basis: 5%;
  text-align: left;
  padding-left: 50px;
}

// .item:not(.item:last-child)::after{
//   content: "";
//   position: absolute;
//   right: 0;
//   top: 20px;
//   width: 1px;
//   height: 27px;
//   background: #dddddd;
// }
.styletwo{
  display: flex;
  justify-content: center;
  align-items: center;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 56px;
    background: #F2F2F2;
    border-radius: 8px;
    button{
      background: none;
    }
  }
}

button {
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
  background: #fff;
}
.item-fixed {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
}
.item-box {
  font-size: 24px;
  color: #333;
  display: flex;
  text-align: center;
  background: #ffffff;
}
.item {
  position: relative;
  flex: 1;
  .content {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
  }
  .has-icon {
    padding-right: 40px;
  }
  .active {
    color: #ED3939;
  }
  .img {
    width: 40px;
    // height: 40px;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -20px;
  }
  .img_single{
    width: 30px;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -13px;
  }
  .has-sigIcon{
    padding-right: 30px;
  }
}
 /deep/.imgstyle {
    width: 40px;
    // height: 40px;
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -20px;

  }
</style>
